import { useActivity } from '@/api/queries';
import { ActivityListSkeleton } from '@/components/feedback/Skeletons';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { relativeTime } from '@/lib/format';

export function ActivityPage() {
  const { data, isLoading } = useActivity(150);

  return (
    <div className="mx-auto flex max-w-5xl flex-col gap-4">
      <header>
        <h1 className="text-2xl font-semibold tracking-tight">Activity feed</h1>
        <p className="text-sm text-muted-foreground">
          Live stream of dispatches, runs, and session changes.
        </p>
      </header>

      <Card>
        <CardHeader>
          <CardTitle className="text-sm">Recent events</CardTitle>
        </CardHeader>
        <CardContent className="p-0">
          {isLoading ? (
            <ActivityListSkeleton rows={12} itemClassName="px-4 py-2" />
          ) : (
            <ul className="max-h-[70vh] divide-y overflow-y-auto text-sm scrollbar-thin">
              {data?.items.map((entry) => (
                <li key={entry.id} className="flex items-center gap-3 px-4 py-2">
                  <span className="w-24 shrink-0 font-mono text-xs text-muted-foreground">
                    {new Date(entry.ts).toLocaleTimeString()}
                  </span>
                  <Badge variant="outline" className="w-24 justify-center text-[10px]">
                    {entry.kind}
                  </Badge>
                  <span className="font-medium">{entry.from ?? '—'}</span>
                  <span className="text-muted-foreground">→</span>
                  <span className="font-medium">{entry.to ?? '—'}</span>
                  <span className="flex-1 truncate text-muted-foreground">{entry.summary}</span>
                  {entry.anomaly && (
                    <Badge variant="destructive" className="text-[10px]">
                      {entry.anomaly}
                    </Badge>
                  )}
                  <span className="text-xs text-muted-foreground">{relativeTime(entry.ts)}</span>
                </li>
              ))}
            </ul>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
